/*
 * Load day.js Plugins
 */
window.dayjs.extend(window.dayjs_plugin_utc);
window.dayjs.extend(window.dayjs_plugin_customParseFormat);
/*
 * Make day.js available via window.moment
 */
window.moment = window.dayjs;
